window.addEventListener('turbo:load', () => {
  Modals.init();
});

const Modals = (function () {
  const modalsSelector = '.sync-modal';
  const modalContentSelector = '.modal-content';
  const modalLinksSelector = '[data-modal]';
  const modalCloseLinksSelector = 'a.sync-modal-close';

  function initialize() {
    observeLinksToShowModals();
    observeLinksToCloseModals();
    observeClicksOutsideModals();
  }

  function observeLinksToShowModals() {
    document.querySelectorAll(modalLinksSelector).forEach(function (linkToShowModal) {
      const selector = linkToShowModal.dataset.modal;
      const modal = document.querySelector(selector);

      linkToShowModal.addEventListener('click', function (event) {
        event.preventDefault();
        showModal(modal, linkToShowModal.dataset.url);
      });
    });
  }

  function observeLinksToCloseModals() {
    document.querySelectorAll(modalCloseLinksSelector).forEach((link) => {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        hideModal(link.closest(modalsSelector));
      });
    });
  }

  function observeClicksOutsideModals() {
    document.querySelectorAll(modalsSelector).forEach((modal) => {
      modal.addEventListener('click', function (event) {
        if (event.target == modal) {
          hideModal(modal);
        }
      });
    });
  }

  function showModal(modal, url) {
    if (url) {
      loadModalContent(modal, url);
    }
    modal.classList.add('active');
    window.scrollTo(0, 0);
  }

  function hideModal(modal) {
    modal.classList.remove('active');
  }

  function loadModalContent(modal, url) {
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const linkToCloseModal = modal.querySelector(modalCloseLinksSelector);
        const modalContent = modal.querySelector(modalContentSelector);
        modalContent.innerHTML = html;
        if (linkToCloseModal) {
          modalContent.prepend(linkToCloseModal);
        }
      });
  }

  return {
    init: initialize,
  };
})();
